import { Component, Input, OnInit } from '@angular/core';
import { JournalPostContent } from '../../interfaces/journal-post';

@Component({
  selector: 'app-journal-post-content',
  templateUrl: './journal-post-content.component.html',
  styleUrls: ['./journal-post-content.component.scss']
})
export class JournalPostContentComponent implements OnInit {
  @Input() content: JournalPostContent[];

  constructor() { }

  ngOnInit() {
  }

}
